import { render, staticRenderFns } from "./AssetSwap.vue?vue&type=template&id=712a5b22&scoped=true"
import script from "./AssetSwap.vue?vue&type=script&lang=js"
export * from "./AssetSwap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a5b22",
  null
  
)

export default component.exports